'use client'

import { useEffect, useState } from "react"
import { usePathname, useSelectedLayoutSegment } from "next/navigation"
import classNames from "classnames"
import Link from "next/link"

export default function ActiveLink({ children, href, className, exact, ...props }) {

    const pathname = usePathname()
    const segment = useSelectedLayoutSegment()
    const [ active, setActive ] = useState(false)

    useEffect(() => {
        if (exact) {
            if (href === pathname) {
                setActive(true)
            }
            else {
                setActive(false)
            }
        }
        else {
            if (href.includes(segment) || pathname.startsWith(href)) {
                setActive(true)
            }
            else {
                setActive(false)
            }
        }
    }, [pathname])

    return (
        <Link
            href={href}
            className={classNames(className, {'active': active})}
            {...props}
        >
            {children}
        </Link>
    )
}